// import React, { useState } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import { useFormik } from "formik";
// import { newPasswordRequest } from "../../api/index";
// import * as Yup from "yup";
// import { faEye, faEyeSlash } from "@fortawesome/free-regular-svg-icons";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { useLocale } from "../../../../context/LocaleContext";
// import Styles from "./styles.module.css";
// import Toast from "../../../../components/toast/toast";
// import { faLock } from "@fortawesome/free-solid-svg-icons";
// import { useIntl } from "react-intl";
// export const NewPassword = () => {
//   const intl = useIntl();

//   const navigate = useNavigate();
//   const { setErrorModalShow } = useLocale();
//   const [type, setType] = useState("password");
//   const [icon, setIcon] = useState(faEyeSlash);
//   const [isToastOpen, setIsToastOpen] = useState(false);
//   const { search } = useLocation();
// const regex = /token=([^,&]+)/;
// const match = search.match(regex);
// let token;

// if (match) {
//   token = match[1];
// } else {
//   console.error("userId or verificationCode not found in the URL");
// }

//   const handleToggle = () => {
//     if (type === "password") {
//       setIcon(faEye);
//       setType("text");
//     } else {
//       setIcon(faEyeSlash);
//       setType("password");
//     }
//   };

//   const formik = useFormik({
//     initialValues: {
//       password: "",
//       confirmPassword: "",
//     },
//     validationSchema: Yup.object({
//       password: Yup.string()
//         .min(8)
//         .matches(
//           /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]+$/,
//           intl.formatMessage({ id: "NewPasswordValidationId2" }),
//         )
//         .required(intl.formatMessage({ id: "NewPasswordValidationId4" })),

//       confirmPassword: Yup.string()
//         .oneOf(
//           [Yup.ref("password"), undefined],
//           intl.formatMessage({ id: "NewPasswordValidationId3" }),
//         )
//         .required(intl.formatMessage({ id: "NewPasswordValidationId4" })),
//     }),
//     onSubmit: (values) => {
//       alert(JSON.stringify(values, null, 2));
//     },
//   });

//   return (
//     <div className={Styles.newPasswordContainer}>
//       <div className={Styles.formNewPasswordContainer}>
//         <form>
//           <label>
//             <div>
//               <FontAwesomeIcon icon={faLock} />
//             </div>

//             <input
//               id="password"
//               name="password"
//               type={type}
//               value={formik.values.password}
//               onChange={formik.handleChange}
//               onBlur={formik.handleBlur}
//               placeholder={intl.formatMessage({ id: "NewPasswordId1" })}
//               className={
//                 formik.errors.password
//                   ? Styles.inputItemContainerError
//                   : Styles.inputItemContainer
//               }
//             />
//             <span className={Styles.eyeBox} onClick={handleToggle}>
//               <FontAwesomeIcon icon={icon} />
//             </span>
//           </label>
//           {formik.touched.password && formik.errors.password ? (
//             <div className={Styles.errorMessage}>{formik.errors.password}</div>
//           ) : null}

//           <div style={{ display: "flex", flexDirection: "column" }}>
//             <label>
//               <div>
//                 <FontAwesomeIcon icon={faLock} />
//               </div>
//               <input
//                 id="confirmPassword"
//                 name="confirmPassword"
//                 type={type}
//                 value={formik.values.confirmPassword}
//                 onChange={formik.handleChange}
//                 onBlur={formik.handleBlur}
//                 placeholder={intl.formatMessage({ id: "NewPasswordId2" })}
//                 className={
//                   formik.errors.confirmPassword
//                     ? Styles.inputItemContainerError
//                     : Styles.inputItemContainer
//                 }
//               />
//               <span className={Styles.eyeBox} onClick={handleToggle}>
//                 <FontAwesomeIcon icon={icon} />
//               </span>
//             </label>
//             {formik.touched.confirmPassword && formik.errors.confirmPassword ? (
//               <div className={Styles.errorMessage}>
//                 {formik.errors.confirmPassword}
//               </div>
//             ) : null}
//           </div>

//           <div className={Styles.newPasswordButtonBox}>
//             <button
//               type="button"
//               onClick={() => {
//                 handleNewPassword();
//               }}
//               className={Styles.newPasswordButton}
//             >
//               {intl.formatMessage({ id: "NewPasswordId3" })}
//             </button>
//           </div>
//         </form>
//       </div>
//       {isToastOpen && (
//         <Toast
//           mainText={intl.formatMessage({ id: "NewPasswordId4" })}
//           additionalText={intl.formatMessage({ id: "NewPasswordId5" })}
//           onClose={() => setIsToastOpen(!isToastOpen)}
//           variant="Success"
//         />
//       )}
//     </div>
//   );
// };

// import React, { useMemo, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { Eye, EyeOff } from "lucide-react";
// import Copyright from "../../../../UI/copyright/copyright";
// import { newPasswordRequest } from "../../api/index";

// import styles from "./NewPassword.module.css";
// import shapeTopRight from "./shapeTopRight.svg";
// import shapeBottomLeft from "./shapeBottomLeft.svg";

// export const NewPassword = () => {
//   const navigate = useNavigate();
//   const [password, setPassword] = useState("");
//   const [confirmPassword, setConfirmPassword] = useState("");
//   const [showPassword, setShowPassword] = useState(false);
//   // const [showConfirm, setShowConfirm] = useState(false);
//   const [submitted, setSubmitted] = useState(false);

//   const checks = useMemo(
//     () => ({
//       length: password.length >= 8,
//       number: /\d/.test(password),
//       symbol: /[@$!%*?&#^()_\-+=]/.test(password),
//     }),
//     [password],
//   );

//   const passwordsMatch = password.length > 0 && password === confirmPassword;
//   const allValid =
//     checks.length && checks.number && checks.symbol && passwordsMatch;

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     setSubmitted(true);
//     if (!allValid) return;
//     // TODO: hook into your real API call
//     navigate("/signin");
//   };
//   const handleNewPassword = async () => {
//     const userData = {
//       newPassword: formik.values.password,
//     };
//     const emptyFields = Object.entries(userData)
//       .filter(
//         ([key, value]) => value === null || value === undefined || value === "",
//       )
//       .map(([key]) => key);

//     if (emptyFields.length > 0) {
//       setIsToastOpen(true);
//       return;
//     }
//     if (userData.newPassword !== formik.values.confirmPassword) {
//       setIsToastOpen(true);
//       return;
//     }
//     const newPassword = await newPasswordRequest(userData, token);
//     if (newPassword) {
//       navigate(`/`);
//     }
//     formik.resetForm();
//   };
//   return (
//     <>
//       <div className={styles.container}>
//         <img
//           className={styles.shapeTopRight}
//           src={shapeTopRight}
//           alt="shapeTopRight"
//         />
//         <img
//           className={styles.shapeBottomLeft}
//           src={shapeBottomLeft}
//           alt="shapeBottomLeft"
//         />

//         <h1 className={styles.title}>Set new password</h1>

//         <form className={styles.formWrapper} onSubmit={handleSubmit} noValidate>
//           <div className={styles.fieldGroup}>
//             <label htmlFor="newPassword" className={styles.label}>
//               New Password
//             </label>
//             <div className={styles.inputWrapper}>
//               <input
//                 id="newPassword"
//                 type={showPassword ? "text" : "password"}
//                 className={styles.input}
//                 placeholder="Enter your new password"
//                 value={password}
//                 onChange={(e) => setPassword(e.target.value)}
//                 autoComplete="new-password"
//               />
//               <button
//                 type="button"
//                 className={styles.eyeButton}
//                 onClick={() => setShowPassword((v) => !v)}
//                 aria-label={showPassword ? "Hide password" : "Show password"}
//               >
//                 {showPassword ? <Eye size={20} /> : <EyeOff size={20} />}
//               </button>
//             </div>
//             <div className={styles.hints}>
//               <span
//                 className={`${styles.hint} ${checks.length ? styles.hintValid : ""}`}
//               >
//                 At least 8 characters
//               </span>
//               <span
//                 className={`${styles.hint} ${checks.number ? styles.hintValid : ""}`}
//               >
//                 Contains a number
//               </span>
//               <span
//                 className={`${styles.hint} ${checks.symbol ? styles.hintValid : ""}`}
//               >
//                 Contains a symbol
//               </span>
//             </div>
//           </div>

//           <div className={styles.fieldGroup}>
//             <label htmlFor="confirmPassword" className={styles.label}>
//               Confirm password
//             </label>
//             <div className={styles.inputWrapper}>
//               <input
//                 id="confirmPassword"
//                 type={showPassword ? "text" : "password"}
//                 className={styles.input}
//                 placeholder="Confirm your password"
//                 value={confirmPassword}
//                 onChange={(e) => setConfirmPassword(e.target.value)}
//                 autoComplete="new-password"
//               />
//               <button
//                 type="button"
//                 className={styles.eyeButton}
//                 onClick={() => setShowPassword((v) => !v)}
//                 aria-label={showPassword ? "Hide password" : "Show password"}
//               >
//                 {showPassword ? <Eye size={20} /> : <EyeOff size={20} />}
//               </button>
//             </div>
//             {submitted && !passwordsMatch && (
//               <span className={styles.errorText}>Passwords do not match</span>
//             )}
//           </div>

//           <button
//             type="submit"
//             className={styles.submitButton}
//             onClick={() => {
//               handleNewPassword();
//             }}
//           >
//             Reset password
//           </button>
//         </form>
//       </div>
//       <Copyright />
//     </>
//   );
// };

import React, { useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Eye, EyeOff } from 'lucide-react';
import { newPasswordRequest } from '../../api/index';

import styles from './NewPassword.module.css';
import shapeTopRight from './shapeTopRight.svg';
import shapeBottomLeft from './shapeBottomLeft.svg';
import { useIntl } from 'react-intl';
export const NewPassword = () => {
	const navigate = useNavigate();
	const intl = useIntl();

	const [password, setPassword] = useState('');
	const [confirmPassword, setConfirmPassword] = useState('');
	const [showPassword, setShowPassword] = useState(false);
	const [showConfirmPassword, setShowConfirmPassword] = useState(false);
	const [submitted, setSubmitted] = useState(false);
	const { search } = useLocation();
	const regex = /token=([^,&]+)/;
	const match = search.match(regex);
	let token;

	if (match) {
		token = match[1];
	} else {
		console.error('userId or verificationCode not found in the URL');
	}
	const checks = useMemo(
		() => ({
			length: password.length >= 8,
			number: /\d/.test(password),
			symbol: /[@$!%*?&#^()_\-+=]/.test(password),
		}),
		[password],
	);

	const passwordsMatch = password.length > 0 && password === confirmPassword;
	const allValid =
		checks.length && checks.number && checks.symbol && passwordsMatch;

	const handleSubmit = async e => {
		e.preventDefault();
		setSubmitted(true);
		if (!allValid) return;

		const newPassword = await newPasswordRequest(
			{ newPassword: password },
			token,
		);
		if (newPassword) {
			navigate('/');
		}
	};

	return (
		<>
			<div className={styles.container}>
				<img
					className={styles.shapeTopRight}
					src={shapeTopRight}
					alt='shapeTopRight'
				/>
				<img
					className={styles.shapeBottomLeft}
					src={shapeBottomLeft}
					alt='shapeBottomLeft'
				/>

				<h1 className={styles.title}>
					{intl.formatMessage({ id: 'NewPasswordID1' })}
				</h1>

				<form className={styles.formWrapper} onSubmit={handleSubmit} noValidate>
					<div className={styles.fieldGroup}>
						<label htmlFor='newPassword' className={styles.label}>
							{intl.formatMessage({ id: 'NewPasswordID2' })}
						</label>
						<div className={styles.inputWrapper}>
							<input
								id='newPassword'
								type={showPassword ? 'text' : 'password'}
								className={styles.input}
								placeholder={intl.formatMessage({ id: 'NewPasswordID3' })}
								value={password}
								onChange={e => setPassword(e.target.value)}
								autoComplete='new-password'
							/>
							<button
								type='button'
								className={styles.eyeButton}
								onClick={() => setShowPassword(v => !v)}
								aria-label={showPassword ? 'Hide password' : 'Show password'}
							>
								{showPassword ? <Eye size={20} /> : <EyeOff size={20} />}
							</button>
						</div>
						<div className={styles.hints}>
							<span
								className={`${styles.hint} ${checks.length ? styles.hintValid : submitted ? styles.hintError : ''}`}
							>
								{intl.formatMessage({ id: 'NewPasswordID4' })}
							</span>
							<span
								className={`${styles.hint} ${checks.number ? styles.hintValid : submitted ? styles.hintError : ''}`}
							>
								{intl.formatMessage({ id: 'NewPasswordID5' })}
							</span>
							<span
								className={`${styles.hint} ${checks.symbol ? styles.hintValid : submitted ? styles.hintError : ''}`}
							>
								{intl.formatMessage({ id: 'NewPasswordID6' })}
							</span>
						</div>
					</div>

					<div className={styles.fieldGroup}>
						<label htmlFor='confirmPassword' className={styles.label}>
							{intl.formatMessage({ id: 'NewPasswordID7' })}
						</label>
						<div className={styles.inputWrapper}>
							<input
								id='confirmPassword'
								type={showConfirmPassword ? 'text' : 'password'}
								className={styles.input}
								placeholder={intl.formatMessage({ id: 'NewPasswordID8' })}
								value={confirmPassword}
								onChange={e => setConfirmPassword(e.target.value)}
								autoComplete='new-password'
							/>
							<button
								type='button'
								className={styles.eyeButton}
								onClick={() => setShowConfirmPassword(v => !v)}
								aria-label={
									showConfirmPassword ? 'Hide password' : 'Show password'
								}
							>
								{showConfirmPassword ? <Eye size={20} /> : <EyeOff size={20} />}
							</button>
						</div>
						{submitted && !passwordsMatch && (
							<span className={styles.errorText}>
								{intl.formatMessage({ id: 'NewPasswordID9' })}
							</span>
						)}
					</div>

					<button type='submit' className={styles.submitButton}>
						{intl.formatMessage({ id: 'NewPasswordID10' })}
					</button>
				</form>
			</div>
		</>
	);
};
